import React, { useEffect, useState } from "react";

const DEFAULT_FALLBACK = "/branding/bbw-logo.jpg";

/**
 * Image that gracefully degrades: primary src -> branded fallback -> hidden.
 * Never leaves a browser broken-image icon on the dashboard.
 */
export default function AdminImageWithFallback({
  src,
  fallbackSrc = DEFAULT_FALLBACK,
  alt = "",
  className = "",
}) {
  const candidates = [...new Set([src, fallbackSrc].filter(Boolean))];
  const [index, setIndex] = useState(0);

  useEffect(() => {
    setIndex(0);
  }, [src]);

  if (candidates.length === 0 || index >= candidates.length) {
    return null;
  }
  return (
    <img
      src={candidates[index]}
      alt={alt}
      className={className}
      loading="lazy"
      onError={() => setIndex((current) => current + 1)}
    />
  );
}
